import { render, staticRenderFns } from "./AppointmentStats.vue?vue&type=template&id=557d4e6e&scoped=true"
import script from "./AppointmentStats.vue?vue&type=script&lang=js"
export * from "./AppointmentStats.vue?vue&type=script&lang=js"
import style0 from "./AppointmentStats.vue?vue&type=style&index=0&id=557d4e6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557d4e6e",
  null
  
)

export default component.exports